// extracted by mini-css-extract-plugin
export var root = "layout-module--root--+UEY-";
export var container = "layout-module--container--eLBMS";
export var header = "layout-module--header--R1XBo layout-module--container--eLBMS";
export var main = "layout-module--main--5VKR9";
export var footer = "layout-module--footer--rX0Dt layout-module--container--eLBMS";